export interface Value {
  value: string | number | boolean;
  key: string | number | boolean;
  selected?: boolean;
}

//Not sure how this will evolve, so put this to make further mods
export interface FilterId {
  id: string;
}

export interface Filter {
  id: string;
  name: string;
  label: string;
  filterType: FilterType;
  multivalued: boolean;
  selected: string[];
  values?: Value[];
  isLoadingValues?: boolean;
}

export interface FilterData {
  filters: Filter[];
  error: boolean;
  errorMessage: string;
  loading: boolean;
}

export enum Namespace {
  WAG_DASHBOARDS2 = 'WAG_DASHBOARDS2',
  grails = 'grails',
}

enum FilterType {
  MUST = 'MUST',
  MUST_NOT = 'MUST_NOT',
}
